import * as actionTypes from "../actions/actionTypes";

const initialState = {};
const getParticipanetsListReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_PARTICIPANETS_LIST:
      return {
        participanets: action.payload.participanets,
      };

    default:
      return state;
  }
};
export default getParticipanetsListReducer;
